import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  min-height: 0; /* prevents overflowing without overflow: hidden */\n  overflow: auto;\n  transform: translateX(", "%);\n  transition: transform ", ";\n  width: ", "%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { property } from '@scp/ui-shared/theme/variables/properties';
export var CarouselContent = styled.div(_templateObject(), function (props) {
  return props.activeIndex * -(100 / props.items.length).toFixed(5);
}, property.transition, function (props) {
  return props.items.length * 100;
});